
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '@/components/common/PageHeader';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface EditReportHeaderProps {
  reportId: string;
  authorName?: string;
  quarter: number;
  year: number;
}

export default function EditReportHeader({ reportId, authorName, quarter, year }: EditReportHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="mb-6">
      <Button
        variant="ghost"
        onClick={() => navigate(`/admin/royalties/${reportId}`)}
        className="mb-2"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Report
      </Button>
      <PageHeader
        title="Edit Royalty Report"
        description={`Update details for Q${quarter} ${year} royalty report for ${authorName || 'Unknown Author'}`}
      />
    </div>
  );
}
